import { Page } from '@app/components/page/Page';
import { GroupIcon } from '@app/components/users/GroupIcon';
import { GroupsHelp } from '@app/modules/admin/components/GroupsHelp';
import { useRouter } from '@mi-front/core';
import { FormattedMessage, useIntl } from 'react-intl';
import { GroupsBreadcrumbs } from '../header';
import { GroupFormMui } from './GroupFormMui';

export const AdminGroupsCreatePage = () => {
  const { $t } = useIntl();
  const { history } = useRouter();
  const title = $t({
    id: 'modulesAdminLocaleEs.m.admin.groups.addScreen.title',
    defaultMessage: 'Crear nuevo grupo',
  });

  return (
    <Page data-cy="groups-add-screen" htmlTitle={title}>
      <Page.Header
        icon={<GroupIcon />}
        title={
          <>
            {title}
            <GroupsHelp
              linkText={
                <FormattedMessage
                  id="admin.groups.addScreen.helpLinkText"
                  defaultMessage="¿Qué es un grupo?"
                />
              }
            />
          </>
        }
        breadcrumbs={
          <GroupsBreadcrumbs
            activeText={$t({
              id: 'common.actions.create',
              defaultMessage: 'Crear nuevo',
            })}
          />
        }
      />
      <Page.Content>
        <GroupFormMui
          onSuccess={(group) => {
            history.push(`/admin/groups/${group.id}`);
          }}
          cancel={() => history.push('/admin/groups')}
        />
      </Page.Content>
    </Page>
  );
};
